import React from 'react';
import Content from './Content';
import { makeStyles } from '@material-ui/core/styles';

import mediaList from './MediaList';
import contestList from './ContestList';

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(3),
    padding: theme.spacing(3, 0),
  },
  frame: {
    border: `2px solid ${theme.props.border.secondary.main}`,
    borderRadius: theme.shape.borderRadius,

    padding: theme.spacing(1, 2.5),
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(1, 3.5),
    },
  },
  containerList: {
    padding: theme.spacing(3, 0),
  },
}));

const Performance = () => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <div className={classes.frame}>
        <div className={classes.containerList}>
          <Content title="メディア" titleSecond="掲載実績" list={mediaList} />
        </div>
        <div className={classes.containerList}>
          <Content title="入賞実績" titleSecond="" list={contestList} />
        </div>
      </div>
    </div>
  );
};

export default Performance;
